import {z as zod} from "zod";

export type ReportsWorkspaceCapabilityConfiguration = Record<string, never>;

export const reportsWorkspaceCapabilityConfigurationValidator: zod.ZodType<ReportsWorkspaceCapabilityConfiguration> = zod.strictObject({});
